<template>
    <div class="list">

    <div class="auctionRegister">
        <h1 class="topTitle">出品登録一覧</h1>
        <!-- <button @click="test">test</button> -->
        <div class="container" >
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                    <label for="itemName">カテゴリ:</label>
                                    <select class="sltBox" v-model="serchItem.category">
                                        <option value="" disabled selected hidden>選択してください</option>
                                        <option v-for="item in categoryList" :value="item.ID" :key="item.ID">
                                            {{ item.CATEGORY_NAME }}
                                        </option>
                                    </select>
                                </li>
                            <li>
                                <label for="itemName">商品名:</label>
                                <input type="text" placeholder="商品名" id="itemName" v-model="serchItem.name" tabindex="1"/>
                            </li>
                            
                            <li class="serchDateBox">
                                <label for="price">販売価格:</label>
                                <input class="searchDate" type="number" placeholder="販売価格（FROM）" id="price" v-model="serchItem.itemPriceStr" tabindex="2"/> ~ 
                                <input class="searchDate" type="number" placeholder="販売価格（TO）" v-model="serchItem.itemPriceEnd" tabindex="2"/>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="userBox">
                <div>
                    <div class="rightBox">
                        <button class="btn regist" @click="setAuction">新規出品登録</button>
                    </div>
                    <table class="selectUser">
                        <tr>
                            <td class="subTitle">設定ユーザー名</td>
                            <td class="subContent">
                                <select class="sltBox" v-model="setUserId" @change="getAuctionInfo">
                                    <option value="" disabled selected hidden>選択してください</option>
                                    <option v-for="item in userList" :value="item.USER_ID" :key="item.USER_ID">
                                        {{ item.USER_NAME }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr v-show="!isDisabled">
                            <td class="subTitle">選択数</td>
                            <td class="subContent">
                                <span class="minText">ラクマ<span class="weight900">{{getSelectNum('r')}}</span>】</span>
                                <span class="minText">【在庫0：<span class="weight900">{{getSelectNumNonQty('r')}}</span>】</span>
                            </td>
                            <td>
                                <button class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca;" @click="allCheck">このページを全てチェックする</button>
                                <button class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="allUnCheck">全てのチェックを外す</button>
                                <button v-if="allShow" class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="showNonQty">在庫0のみ表示する</button>
                                <button v-if="!allShow" class="btn" style="line-height: 1;background-color: #0b5ed7;border-color: #0a58ca; margin-top: 5px;" @click="setAuction">全て表示する</button>
                            </td>
                        </tr>
                    </table>
                
                </div>
                <br>
                
            </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="modalOpen">出品時間設定</button>
                <button class="btn submit" @click="register" :disabled="isDisabled" >登録する</button>
            </div>
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            出品サイト
                        </th>                        
                        <th class="listTitle">
                            商品画像
                        </th>
                        <th class="listTitle">
                            商品名
                        </th>
                        <th class="listTitle">
                            カテゴリ
                        </th>
                        <th class="listTitle">
                            販売価格
                        </th>
                        <th class="listTitle">
                            在庫数
                        </th>
                        <th class="listTitle">
                            備考
                        </th>
                    </tr>
                    <tr v-for="(item , index) in getItems" :key="item.ITEM_ID" v-show="item.display && setUserId != ''">
                        <td class="listItem siteType">
                            
                            <input type="checkbox" v-model="item.siteType" :id="index + ((currentPage -1) *  perPage)+'_r'" value="r" @change="arrUp" 
                            
                            checked=true>
                            <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_r'">ラクマ</label>
                        
                        </td>
                        <td class="listItem center">
                            <img class="itemImg" :src="item.TMP_IMG">
                        </td>
                        <td class="listItem">
                            {{item.ITEM_TITLE}}
                        </td>
                        <td class="listItem">
                            {{ item.R_CATEGORY }}
                            {{getCategoryName(item.R_CATEGORY)}}
                        </td>
                        <td class="listItem">
                            {{item.ITEM_PRICE}}<p class="unit">円</p>
                        </td>
                        <td class="listItem">
                            {{item.STOCK_QUANITY}}<p class="unit">個</p>
                        </td>
                        <td class="listItem">
                            {{item.MEMO}}
                        </td>
                        
                    </tr>
                    
                </table>
                
                <div class="pdgTop10">
                    <vuejs-paginate
                    :page-count="getPaginateCount"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :click-handler="paginateClickCallback"
                    :container-class="'pagination justify-content-center'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :first-last-button="true"
                    :first-button-text="'<<'"
                    :last-button-text="'>>'"
                    ></vuejs-paginate>
                </div>
                
            </div>

            <div class="overlay" v-show="modalFlg">
                    <div class="createModal">
                    <div class="swal2-popup swal2-modal swal2-show" style="display: grid;" >
                        <div class="createUser">
                            <div class="login_form_top">
                                <h1 class="title">出品・値引き時間設定</h1>
                            </div>
                            <div class="formBox">
                                <h2 id="userName" class="itemLabel">毎日出品</h2>
                                    <vue-timepicker
                                    format="HH"
                                    v-model="grpObj.SELL_TIME"
                                    placeholder="00"
                                    close-on-complete
                                    hide-clear-button
                                    ></vue-timepicker>
                                    <p class="unit">時(出品)</p><br>
                                    <vue-timepicker
                                        format="HH"
                                        v-model="grpObj.DOWN_TIME"
                                        placeholder="00"
                                        close-on-complete
                                        hide-clear-button
                                    ></vue-timepicker>
                                    <p class="unit">時(値引き)</p>
                            <div class="btnBox">
                                <button class="btn repage"  @click="modalFlg = !modalFlg">キャンセル</button>
                                <button class="btn"  @click="setWgroup">更新</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            
        </div>
    </div>
    </div>
</template>
<script>
import {itemRepository} from '@/Repositories/itemRepository.js'
import {userRepository} from '@/Repositories/userRepository.js'
import {m_auction_repository} from '@/Repositories/u010_r_m_auction_repository.js'
import {group_repository} from '@/Repositories/u011_r_group_repository.js'
import {w_category_repository} from '@/Repositories/u012_r_w_category_repository.js'
import VueJsPaginate from 'vuejs-paginate';
import Datepicker from 'vuejs-datepicker';

import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {ja} from 'vuejs-datepicker/dist/locale';
export default {
    
  data() {
        return {
            /******************
             * Datepicker設定
            ******************/
            ja:ja,
            disabledDates:{
                from:new Date()
            },
            /******************
             * 表示フラグ
            ******************/
            isShowSerchBox:false,
            isDisabled:true,
            maxItem:0,
            modalFlg:false,
            allShow:false,
            /******************
             * ユーザー情報
            ******************/
            userInfo:{},
            userList:[],
            setUserId:'',
            tmpSiteType:null,
            /******************
             * 商品情報
            ******************/
            itemList:[{siteType:[],isAllSelected: false,}],
            tmpItemList:[{siteType:[],isAllSelected: false,}],
            /******************
             * 検索ボックス
            ******************/
            serchItem : {
                name:null,
                itemPrice:null,
                createDateStr:null,
                createDateEnd:null,
                category:null,
            },
            categoryList:[],
            grpObj:{},
            /******************
             * ページング設定
            ******************/
            currentPage: 1,
            perPage: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
        "vue-timepicker": VueTimepicker,
        Datepicker,
    },
  methods:{
    modalOpen(){
        this.grpObj = Object.assign({}, this.grpObj, {});
        this.getWgroup();
        this.modalFlg = !this.modalFlg;
        
    },
    getWgroup(){
        group_repository.get(this.setUserId).then(res=>{
            this.grpObj = Object.assign({}, this.grpObj, {
                USER_ID : this.setUserId,
                SELL_TIME : !res.data.SELL_TIME?'00' : res.data.SELL_TIME,
                DOWN_TIME : !res.data.DOWN_TIME?'00' : res.data.DOWN_TIME,
            });
        });
    },
    setWgroup(){
        if(typeof this.grpObj.SELL_TIME === 'object') this.grpObj.SELL_TIME = this.grpObj.SELL_TIME.HH;
        if(typeof this.grpObj.DOWN_TIME === 'object') this.grpObj.DOWN_TIME = this.grpObj.DOWN_TIME.HH;
        this.grpObj.PARENT_ID = this.userInfo.USER_ID;
        group_repository.upd(this.grpObj)
        .then(res=>{
            this.$swal("更新しました", {
                        icon: "success",
                    })
        });
        this.modalFlg = false;
            
        
    },
      arrUp(){
        this.tmpItemList.splice();
      },
      getSelectNum(type){
        var selectedArr = this.itemList.filter(item=>{
            return item.siteType.indexOf(type) != -1;
        });
        return selectedArr.length;
      },
      getSelectNumNonQty(type){
        var selectedArr = this.itemList.filter(item=>{
            return item.siteType.indexOf(type) != -1 && item.STOCK_QUANITY == '0';
        });
        return selectedArr.length;
      },
      showNonQty(){
        this.tmpItemList = this.tmpItemList.filter(x=> x.STOCK_QUANITY == '0');
        this.allShow = false;
      },
      getCategory(){
        w_category_repository.get(this.userInfo.USER_ID).then(res=>{
            this.categoryList = res.data;
        })
    },
    getCategoryName(id){
        if(this.categoryList.length == 0) return;
        var category = this.categoryList.find(x=> x.ID == id);
        if(category) return category.CATEGORY_NAME
        else return '';
    },
      serch(){
        let vm = this;
        var tmpItemList = [...vm.itemList];
        if(vm.serchItem.category){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.R_CATEGORY == vm.serchItem.category;
            });
        }
        
        if(vm.serchItem.name){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.ITEM_TITLE.match(vm.serchItem.name) != null
            })
        }
        if(vm.serchItem.itemPriceStr){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.ITEM_PRICE) >= Number(vm.serchItem.itemPriceStr);
            });
        }
        if(vm.serchItem.itemPriceEnd){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return  Number(item.ITEM_PRICE) <= Number(vm.serchItem.itemPriceEnd) ;
            });
        }
        vm.tmpItemList = tmpItemList;
    },
    clear(){
        this.tmpItemList = this.itemList;
        console.log(this.tmpItemList);
        for(var i=0; i< this.tmpItemList.length; i++){
            this.tmpItemList[i].display =true;
        }
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    
    register(data){
        let vm = this;
           this.$functions.swAlert(vm, "warning", "出品登録します。")
           .then((btn) => {
            if (btn.isConfirmed) {
                var postData = [];
                for(var i =0; i < vm.tmpItemList.length; i++){
                    var putCount = 0;
                    if(vm.tmpItemList[i].siteType.length == 0){
                        putCount = -1;
                    }
                    postData.push({
                        USER_ID: vm.setUserId,
                        ITEM_ID: vm.tmpItemList[i].ITEM_ID,
                        PUT_COUNT:putCount,
                        IS_SELL	:vm.tmpItemList[i].siteType.indexOf('r') != -1? 1:0,
                        PARENT_ID : this.userInfo.USER_ID
                    });
                }
                m_auction_repository.upd(postData)
                .then(res=>{
                    this.$swal("登録しました", {
                        icon: "success",
                    }).then(()=>{
                        this.$router.go({path: this.$router.currentRoute.path, force: true})
                    });
                })
            }
        });
          
      },
      init(){
            let vm =this;
            vm.userInfo = vm.$functions.getSStorage('userInfo');
            userRepository.methods.getChild()
            .then(res=>{
                var data = res.data;
                for(var i=0; i< data.length; i++){
                    if(data[i].siteType) data[i].siteType = data[i].siteType.split(',');
                }
                
                vm.userList = data;
                vm.setUserId = vm.userList[0].USER_ID;
                vm.getAuctionInfo(vm.setUserId);
            })
            this.getCategory();
        },
        getAuctionInfo(){
            let vm =this;
            //最大出品数設定
            vm.maxItem  = vm.userInfo.MAX_SELE_NUM;
            m_auction_repository.get(vm.setUserId)
            .then(res=>{
                var data = res.data;
                vm.tmpSiteType = data;
                vm.tmpItemList = [...vm.itemList];
                
                vm.setSiteType();
                vm.tmpItemList = vm.tmpItemList.filter(item=>{
                    return item.display == true;
                })
            })
        },
        setSiteType(){
            let vm = this;
            var dItem = null;
            var data = vm.tmpSiteType;
            vm.tmpItemList.filter((item, i, arr)=> {
                if(data){
                    dItem = data.find(d=> d.ITEM_ID == item.ITEM_ID);
                }
                if(dItem){
                    arr[i].siteType = [];
                    if(dItem.IS_SELL == '1') arr[i].siteType.push('r');
                    arr[i].siteType.length <= 0 ?arr[i].display = false : arr[i].display = true;
                }else{
                    
                    arr[i].isAllSelected = false;
                    arr[i].display = false;
                    arr[i].siteType = [];
                }
            })
        },
        setAuction(){
            let vm = this;
            vm.isDisabled = false;
            vm.allShow = true;
            vm.tmpItemList = [...vm.itemList];
                
            vm.setSiteType();
            vm.clear();
        },
        getAllItem(){
            let vm =this;
            itemRepository.methods.getAll()
            .then(res=>{
                vm.itemList = res.data;
                for(var i=0; i<vm.itemList.length; i++){
                    vm.itemList[i].siteType = [];
                    vm.itemList[i].display = true;
                    vm.itemList[i].gloup = 0;
                    vm.itemList[i].time = 0;
                }
                vm.init();
            })
        },
        returnPage(){
            let vm = this;
            vm.$router.back();
        },
        allUnCheck(){
            
            for(var item of this.tmpItemList){
                item.siteType = [];
            }
            this.tmpItemList.splice();
        },
        allCheck(){
            console.log(this.tmpItemList);
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            var items = this.tmpItemList.slice(start, end);
            for(var item of items){
                if(item.STOCK_QUANITY > 0){
                    if(!Array.isArray(item.siteType))item.siteType = [];
                    if(item.siteType.indexOf('r') == -1)
                    {
                        item.siteType.push('r');
                    }
                }
                
            }
            this.tmpItemList.splice();
        }
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.tmpItemList.length / this.perPage);
        },
        getItems () {
            if(this.itemList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpItemList.slice(start, end);
        }
    },
   created:async function(){
        let vm =this;
        await vm.getAllItem();

  },
  
}
</script>

<style lang="scss">
    @import "../style/auctionRegister.scss";
</style>
<style scoped>
.createModal{
    height: 70%;
    position: fixed;
    overflow: scroll;
}
.createModal::-webkit-scrollbar {  
  display: none; /*Google Chrome、Safari、Microsoft Edge対応のスクロールバー非表示コード*/
}
</style>